import React, { useEffect, useRef, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import LockIcon from "@mui/icons-material/Lock";
import CloseIcon from "@mui/icons-material/Close";
import { useMediaQuery, useTheme } from "@mui/material";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
} from "@mui/material";

import { ROLES } from "../../helpers/constants";
import PropertySearchType from "./PropertySearchType";
import CategoryWisePricing from "./CategoryWisePricing";
import Aurthorised from "../../../assets/price_F&Q/aurthorize.png";
import { brokerAgentsAction } from "../../../redux/slices/brokers";
import SecurityInfoAndCardPayment from "./SecurityInfoAndCardPayment";
import PersonalTokenScreen from "../../user-signup/personalTokenScreen";
import {
  clearStoredPromoCode,
  findAllowedPrefixData,
  getObjLength,
  userHasSecurityPin,
} from "../../helpers/utils";
import { isEldoradoFromWhere, clearEldoradoAdminEnhancedBillingChoice, isAdminEldoradoComplimentaryEnhancedSelected } from "../../helpers/eldoradoSignup";
import { isAffiliateUser } from "../../helpers/affiliateSignup";
import { clearPropertySearchMode } from "../../helpers/enhancedMonitoringSearchRules";
import { userProfileAction } from "../../../redux/slices/user/userProfileSlice";
import { userSigupAction } from "../../../redux/slices/user/userSignUpSlice";
import { propertiesAction } from "../../../redux/slices/properties/propertiesSlice";
import { propertyUsersAction } from "../../../redux/slices/admin/propertyUsers/propertyUsersSlice";
import { userHasPhoneTosConsent } from "../../admin/PropertyUsers/userDisplayHelpers";
import {
  CAR_SKIP_OWNER_PIN,
  clearCarEnrollmentSession,
  isCarAddPropertyClient,
  rememberCarPortfolioIds,
  shouldSkipCarOwnerPin,
  skipCarOwnerVerifiedPage,
} from "../../for-service-provider/carPortfolioStatus";
import CarInviteChoice from "../../car/CarInviteChoice";
import { Loader } from "../../common/loader";
import { carPaymentEndsWithWelcomeEmail } from "../../for-service-provider/servicerOnboardingDisplay";
import AlertDialog from "../../common/AlertDialog";
import { postAPIPayload } from "../../../apis/postApi";

import "../../../styles/properties.scss";

const carPrefillEnrollmentKind = () => {
  try {
    return (
      JSON.parse(localStorage.getItem("carPortfolioPrefill") || "{}")
        .enrollment_kind || null
    );
  } catch {
    return null;
  }
};

const AddPropertyPopup = ({
  getPropertyList,
  classes,
  showBtn = true,
  initialyAddPropertyModal = false,
  setIsAddPropertyModalOpen = () => {},
  handleCloseModal = () => {},
  isByPassOptionAvailable = false,
  from = "",
  isUserCreateProperty = false,
  setIsMapDisplay = () => {},
  isMapDisplay,
  callListingAPI = true,
  selectedRowData = {},
  step = null,
  user_id = null,
  showSecurityHeaderToCheckout = false,
  isAdminCreateUser = false,
  isResumeSignup = false,
  closeAfterAddingProperty = false,
  promoCode = undefined,
  isAssistant = false,
  enablePaymentScreen = true,
  category = "complete_protection",
  isUpgradeCategory = false,
  userEmail = undefined,
  isTailwindComponent = false,
  isServiceProvider = false,
  isFromRiskReport = false,
  disableBasicMonitoring = false,
  onGenerateSecurityQuestions = () => {},
  isEnhancedToCompleteProtection = false,
  ownershipVerificationAlreadyComplete = false,
  ownershipVerifiedViaId = false,
  initialSkipVerification = false,
  agreementCategory = undefined,
  skipSecurityPinAfterPayment = false,
  // CAR agent buying for a client: Complete Protection only, no category step.
  completeProtectionOnly = false,
}) => {
  const dispatch = useDispatch();
  const dialogContentRef = useRef(null);

  // states
  const [addPropertyModal, setAddPropertyModal] = useState(
    initialyAddPropertyModal,
  );
  const [screen, setScreen] = useState(step || "security");
  // C.A.R. agent finishing a client's signup with the welcome email after payment.
  const [carWelcomeEmail, setCarWelcomeEmail] = useState({
    sending: false,
    error: "",
  });
  // Add Property for a past client: Invite or Purchase before the plans.
  const [carPurchaseChosen, setCarPurchaseChosen] = useState(false);
  const [carChoiceRows, setCarChoiceRows] = useState({ loading: false, ids: [] });
  const [selectedData, setSelectedData] = useState({});
  const [skipVerification, setSkipVerification] = useState(
    initialSkipVerification,
  );
  const [selectedCategory, setSelectedCategory] = useState(category);
  const flowSourceRef = useRef(
    `add-property-${Math.random().toString(36).slice(2)}`,
  );

  // Register as an in-progress flow while the dialog is open so the customer
  // list POST does not reset this modal's state mid-flow (deferred until close).
  useEffect(() => {
    if (!addPropertyModal) {
      return undefined;
    }
    const source = flowSourceRef.current;
    dispatch(propertiesAction.setPropertyFlowOpen({ source, open: true }));
    return () => {
      dispatch(propertiesAction.setPropertyFlowOpen({ source, open: false }));
    };
  }, [addPropertyModal, dispatch]);

  // Keep selectedCategory aligned when resume/create passes an updated category.
  useEffect(() => {
    if (category) {
      setSelectedCategory(category);
    }
  }, [category]);

  const theme = useTheme();
  const isPadding = useMediaQuery(theme.breakpoints.down(884));
  const isSubscriptionCloseCompact = useMediaQuery(
    theme.breakpoints.down(1100),
  );
  const { propertyQuestion, getPropertyData, selectedProperty, isQuestionByPass } =
    useSelector((state) => state.properties);
  const { data: userData } = useSelector(
    (state) => state?.userProfile?.userProfileDetails,
  );
  const { servicerProfessionalDetails } = useSelector(
    (state) => state?.servicerProfile,
  );
  const { isAnualPlanScreen } = useSelector((state) => state?.signUpUser);
  console.log(addPropertyModal, "YYYY ->", initialyAddPropertyModal);

  useEffect(() => {
    if (!isByPassOptionAvailable) {
      return;
    }
    // Upgrade modal already recorded the admin's Yes/No bypass choice via
    // setIsQuestionByPass. Do not override "No — require security questions".
    if (isUpgradeCategory) {
      return;
    }
    // Client enrollment (admin create-user or SP /clients/* with isAdminCreateUser):
    // always bypass owner questions. SP personal /servicer-properties does not
    // set isAdminCreateUser, so that flow still requires security questions.
    // Otherwise require phone TOS consent (existing admin workspace behavior).
    if (
      isAdminCreateUser ||
      userHasPhoneTosConsent(selectedRowData)
    ) {
      dispatch(propertiesAction.setIsQuestionByPass(true));
    }
  }, [
    dispatch,
    isAdminCreateUser,
    isByPassOptionAvailable,
    isUpgradeCategory,
    selectedRowData,
  ]);

  const allowedPrefix = findAllowedPrefixData(selectedRowData.source);
  const isCustomer = userData?.role?.includes(ROLES?.customer);
  const isAdmin =
    userData?.role?.includes(ROLES?.admin) ||
    userData?.role?.includes(ROLES?.subAdmin);

  // Admin workspace Add Property for an existing user with Enhanced Monitoring.
  // Enhanced never shows ownership verification: Paid Enhanced goes straight
  // to card payment; Complimentary Enhanced enrolls from Find Property.
  const isAdminWorkspaceEnhancedAddProperty =
    from === "add-property" &&
    isAdmin &&
    !isServiceProvider &&
    !isAdminCreateUser &&
    !isResumeSignup &&
    !isUpgradeCategory &&
    !isUserCreateProperty &&
    selectedCategory === "enhanced_monitoring";

  const handleOpenAddPropertyModal = () => {
    setScreen("security");
    dispatch(propertiesAction.clearPropertiesList());
    setAddPropertyModal(true);
    setIsMapDisplay(false);
    setSkipVerification(false);
    sessionStorage.removeItem("addPropertyMailingNoMatch");
    clearPropertySearchMode();
  };
  // handle close property modal
  const handleCloseAddPropertyModal = (type) => {
    console.log("YYY close called");

    if (type === "error") {
      dispatch(propertiesAction.fethPayment());
    } else {
      // Clear shared pricing/promo so the next Add Property / Subscription / Upgrade
      // flow does not reuse a previous Order Summary breakdown.
      dispatch(userSigupAction.fetchTotalPaymentDetails({}));
      clearStoredPromoCode();
      dispatch(propertiesAction.clearPropertiesList());
      dispatch(userSigupAction.fetchDefaultOwnerNameData({}));
      dispatch(propertiesAction.generateQuestionsInputParams({}));
      dispatch(propertiesAction.fetchUserProperty({}));
      clearPropertySearchMode();
      clearEldoradoAdminEnhancedBillingChoice();

      setIsMapDisplay(true);

      setSkipVerification(false);
      // Reset per-run screen state so a reopen never inherits the last run.
      setSelectedData({});
      setCarPurchaseChosen(false);
      setCarChoiceRows({ loading: false, ids: [] });
      setSelectedCategory(category);
      // if (selectedRowData?.json_last_step?.step < 4) {
      //   console.log("YYY payment completed");
      //   setScreen("security-pin");
      // } else {
      setAddPropertyModal(false);
      setIsAddPropertyModalOpen(false);
      getPropertyList();
      setScreen("security");
      handleCloseModal();
      // }
    }
  };
  console.log("YYY Screen -->", screen);

  const carClientId = user_id || selectedRowData?.user_id || selectedRowData?.id;

  // A C.A.R. agent adding a Previously closed property for a client is asked
  // Invite or Purchase before the plans, as in Add Client. Several steps open
  // the plans directly, so the choice stands in for them until Purchase.
  const showCarInviteChoice =
    screen === "subscriptions" &&
    isServiceProvider &&
    completeProtectionOnly &&
    !carPurchaseChosen &&
    carPrefillEnrollmentKind() === "post_close" &&
    isCarAddPropertyClient(carClientId);

  // The invitation goes to the property's portfolio row, which the plans
  // screen would otherwise create: make it now (the same call; it reuses the row).
  useEffect(() => {
    if (!showCarInviteChoice || !selectedProperty?.property_id) {
      return undefined;
    }
    let cancelled = false;
    setCarChoiceRows({ loading: true, ids: [] });
    postAPIPayload({
      url: "service-provider/car-portfolio/added-property",
      data: {
        client_user_id: carClientId,
        property_ids: [selectedProperty.property_id],
        enrollment_kind: "post_close",
      },
      token: true,
    })
      .then((response) => {
        if (cancelled) return;
        const ids = response?.success ? response?.data?.ids || [] : [];
        if (ids.length) {
          rememberCarPortfolioIds(ids);
        }
        setCarChoiceRows({ loading: false, ids });
      })
      .catch(() => {
        if (!cancelled) setCarChoiceRows({ loading: false, ids: [] });
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showCarInviteChoice, selectedProperty?.property_id]);

  const leaveCarInviteChoice = () => {
    clearCarEnrollmentSession();
    handleCloseAddPropertyModal("success");
  };

  // After the payment success modal: finish the client's signup with the
  // welcome email (no security PIN screen) for a C.A.R. agent's Add Property.
  const sendCarClientWelcomeEmail = async () => {
    const clientId = carClientId || null;
    setCarWelcomeEmail({ sending: true, error: "" });
    let response = null;
    try {
      response = await postAPIPayload({
        url: "send-welcome-email",
        data: {
          user_id: clientId,
          from_admin: 1,
          step: 7,
          step_key: "SEND_WELCOME_EMAIL",
        },
      });
    } catch (error) {
      response = { success: false, message: error?.message };
    }
    if (!response?.success) {
      setCarWelcomeEmail({
        sending: false,
        error:
          response?.message ||
          "The payment went through, but the welcome email could not be sent.",
      });
      return;
    }
    setCarWelcomeEmail({ sending: false, error: "" });
    handleCloseAddPropertyModal("success");
  };

  const completedProcess = () => {
    setScreen("security");
    handleCloseModal();
    localStorage.removeItem("param");
    localStorage.removeItem("fixParams");
    localStorage.removeItem("searched_Add");
    localStorage.removeItem("searched_Add_popup");
    localStorage.removeItem("county_data");
    clearPropertySearchMode();
    dispatch(userSigupAction.userAddedByAdmin(false));
    dispatch(userSigupAction.clearData());
    dispatch(propertyUsersAction.clearData({}));
    dispatch(propertiesAction.resetState());
  };

  useEffect(() => {
    // A servicer's Add Property starts with no staged property list: one left
    // by another flow (e.g. an unpaid Add Client) must never be quoted or paid.
    if (
      isServiceProvider &&
      from === "add-property" &&
      !isUpgradeCategory &&
      !isEnhancedToCompleteProtection
    ) {
      dispatch(
        userSigupAction.setPropertiesId({ propertyIds: [], properties: [], ids: [] }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Upgrade flows open this popup after Order Summary may already have an
    // applied promo — do not wipe it before the payment screen autofills.
    if (isUpgradeCategory || isEnhancedToCompleteProtection) {
      localStorage.removeItem("searched_Add_popup");
      return;
    }
    clearStoredPromoCode();
    localStorage.removeItem("referralCode");
    localStorage.removeItem("searched_Add_popup");
  }, [isEnhancedToCompleteProtection, isUpgradeCategory]);

  useEffect(() => {
    if (!initialyAddPropertyModal) {
      return;
    }
    setScreen(step || "security");
    // if (!isUpgradeCategory) {
    //   dispatch(propertiesAction.clearPropertiesList());
    // }
    setAddPropertyModal(true);
    setSkipVerification(initialSkipVerification);
    sessionStorage.removeItem("addPropertyMailingNoMatch");
    clearPropertySearchMode();
  }, [dispatch, initialSkipVerification, initialyAddPropertyModal, step]);

  useEffect(() => {
    if (!initialyAddPropertyModal || !isUpgradeCategory) {
      return;
    }
    const isCompleteProtectionTarget =
      category === "complete_protection" ||
      selectedCategory === "complete_protection";
    if (!isCompleteProtectionTarget || !isCustomer) {
      return;
    }
    dispatch(
      userProfileAction.userProfileData({
        url: "profile",
        data: {},
        token: true,
      }),
    );
  }, [
    category,
    dispatch,
    initialyAddPropertyModal,
    isCustomer,
    isUpgradeCategory,
    selectedCategory,
  ]);

  useEffect(() => {
    console.log("propertyQuestion  ==>", propertyQuestion);
    const isSpPersonalAddProperty =
      isServiceProvider && !isAdminCreateUser && !isUpgradeCategory;

    // PropertySearchType already routed Enhanced (payment or Find Property);
    // do not bounce to plans or ownership questions from this response.
    if (isAdminWorkspaceEnhancedAddProperty) {
      return;
    }

    if (propertyQuestion?.success && propertyQuestion?.data?.is_verified) {
      console.log(
        selectedProperty,
        "subscription screen called getPropertyData, 2",
        getPropertyData,
      );
      if (Object.keys(selectedProperty).length > 0) {
        let propertyData = selectedProperty?.json_response;
        setSelectedData({
          property_id: selectedProperty?.property_id,
          state_code: propertyData.mm_fips_state_code,
          user_id:
            userData?.user_id || servicerProfessionalDetails?.data?.user_id,
        });

        console.log("answers object==>", selectedData);
      }
      if (isResumeSignup) {
        // Admin resume signup (e.g. step 2 / Owner Verified → Add Another):
        // always return to Owner Verified; plans come from that screen's Next.
        setScreen("propertyList");
      } else if (
        selectedCategory === "enhanced_monitoring" &&
        isAdminEldoradoComplimentaryEnhancedSelected()
      ) {
        // Complimentary Enhanced: stay on Find Property (PropertyInfoBox).
      } else if (isUpgradeCategory && isServiceProvider) {
        // SP client upgrade from /clients/{id}: go to plans / payment choice.
        setScreen("subscriptions");
      } else if (isAdminCreateUser) {
        setScreen("propertyList");
      } else if (isCustomer || isSpPersonalAddProperty) {
        // Customer / SP personal: post-search nav goes to categoryWisePricing;
        // do not skip that screen by jumping to subscriptions here.
      } else {
        setScreen("subscriptions");
      }
    } else {
      setSelectedData({});
    }

    if (
      propertyQuestion?.data?.questions?.length > 0 &&
      propertyQuestion?.success &&
      !propertyQuestion?.data?.is_verified
    ) {
      console.log("security screen called");
      if (isCustomer || isSpPersonalAddProperty) {
        // Plan picker is shown first for these flows. Ownership verification
        // is opened from CategoryWisePricing after CP Order Summary.
      } else {
        setScreen("questions");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propertyQuestion]);

  useEffect(() => {
    // Scroll the dialog content to the top whenever the screen changes
    if (dialogContentRef?.current) {
      dialogContentRef.current.scrollTop = 0;
    }
  }, [screen]);

  useEffect(() => {
    // Scroll the dialog content to the top whenever the screen changes
    if (getObjLength(allowedPrefix)) {
      let source = allowedPrefix?.source;
      let brokerName = allowedPrefix?.prefix;

      const URL = `get-broker-details/${brokerName}?source=${source}`;

      dispatch(
        brokerAgentsAction.getBrokerDetails({
          url: URL,
          data: { source },
        }),
      );
    }
  }, [allowedPrefix]);
  console.log("QQQ 3 -->", screen);

  return (
    <>
      {showBtn && (
        <Button
          variant="contained"
          className={classes}
          onClick={(e) => {
            e.preventDefault();
            handleOpenAddPropertyModal();
          }}
        >
          Add property
        </Button>
      )}

      <Dialog
        open={addPropertyModal}
        fullWidth={true}
        maxWidth={isUpgradeCategory && screen === "security" ? "sm" : "lg"}
        onClose={handleCloseAddPropertyModal}
        className={
          isUpgradeCategory
            ? screen === "security"
              ? null
              : "add-propery-modal zoom-modal-wrapper upgrade-modal"
            : "add-propery-modal zoom-modal-wrapper"
        }
      >
        <DialogContent
          className="bg-white"
          dividers={true}
          sx={{ px: "2 !important", position: "relative" }}
          ref={dialogContentRef}
        >
          {(screen === "security-pin" ||
            screen === "2fa" ||
            screen === "propertyList" ||
            screen === "bio-metric" ||
            screen === "signature" ||
            (showSecurityHeaderToCheckout && screen === "cardsInfo") ||
            screen === "welcome" ||
            screen === "beneficiaries" ||
            screen === "categoryWisePricingFromAdmin" ||
            screen === "categoryWisePricing") && (
            <>
              <Typography
                align="center"
                variant="subtitle1"
                className={`py-1 ${isTailwindComponent ? "" : "formHeader"} zoom-container`}
                color={"white"}
                //  sx={{maxWidth:"880px"}}
                sx={{
                  position: "relative",
                  backgroundColor: isTailwindComponent
                    ? "#4ba5dd !important"
                    : "",
                  borderRadius: isTailwindComponent ? "6px 6px 0px 0px" : 10,
                }}
              >
                <LockIcon sx={{ fontSize: 12 }} className="me-1" />
                Secure connection
              </Typography>
              <Button
                onClick={handleCloseAddPropertyModal}
                className={`modal-close-btn close-text hide-inner-close ${screen === "categoryWisePricing" ? "close_btn_icon" : ""}`}
                style={{
                  position: "absolute !important",
                  top: 14,
                  right: 76,
                  background: "transparent",
                  textTransform: "none",
                  backgroundColor: isTailwindComponent
                    ? "#4ba5dd !important"
                    : "",
                }}
              >
                {" "}
                <CloseIcon
                  className="hide-inner-close"
                  sx={{ fontSize: 20, color: "white" }}
                />
              </Button>
            </>
          )}

          <Button
            onClick={handleCloseAddPropertyModal}
            className={`modal-close-btn ${isTailwindComponent && screen === "subscriptions" ? "" : "hide-outer-close"} ${isTailwindComponent ? "close-text-tailwind" : "close-text"}`}
            style={{
              position: "absolute",
              right:
                screen === "subscriptions" && isSubscriptionCloseCompact
                  ? 15
                  : 5,
              top:
                screen === "subscriptions" && isSubscriptionCloseCompact
                  ? 15
                  : 5,
              background: "transparent",
              textTransform: "none",
              zIndex:
                isTailwindComponent && screen === "subscriptions"
                  ? 10
                  : undefined,
            }}
          >
            {!(
              isTailwindComponent &&
              screen === "subscriptions" &&
              isSubscriptionCloseCompact
            ) && "Close"}
            <CloseIcon
              className={
                isTailwindComponent && screen === "subscriptions"
                  ? ""
                  : "hide-outer-close"
              }
              sx={{
                fontSize:
                  screen === "subscriptions" && isSubscriptionCloseCompact
                    ? "1.5rem"
                    : "2.5rem",
                color:
                  isTailwindComponent &&
                  screen === "subscriptions" &&
                  isSubscriptionCloseCompact
                    ? "white"
                    : isTailwindComponent
                      ? "#4ba5dd !important"
                      : "#15be53",
              }}
            />
          </Button>
          <DialogContentText
            id="scroll-dialog-description"
            // ref={descriptionElementRef}
            tabIndex={-1}
            className={`${
              isAnualPlanScreen && !isTailwindComponent && "border_clasess"
            } zoom-container `}
            sx={isPadding ? { paddingBottom: "110px" } : undefined}
          >
            {screen === "2fa" && (
              <PersonalTokenScreen
                onBtnClick={() => {
                  dispatch(propertiesAction.clearPropertiesList());
                  dispatch(userSigupAction.fetchDefaultOwnerNameData({}));
                  if (
                    selectedRowData?.investor_id ||
                    selectedRowData?.county_user_id ||
                    isEldoradoFromWhere(selectedRowData) ||
                    isAffiliateUser(selectedRowData)
                  ) {
                    setScreen("propertyList");
                  } else {
                    setScreen("security");
                  }
                }}
                missingEmail={false}
                missingPhone={false}
                user_id={user_id}
                selectedRowData={selectedRowData}
                isAdmin={true}
                userEmail={userEmail}
              />
            )}

            {screen === "categoryWisePricingFromAdmin" && (
              <CategoryWisePricing
                setSelectedCategory={setSelectedCategory}
                selectedCategory={selectedCategory}
                onChangeModalScreen={() => setScreen("security")}
                handleCloseAddPropertyModal={handleCloseAddPropertyModal}
                from={from}
                uid={user_id}
                selectedData={selectedRowData}
                isUserCreateProperty={isUserCreateProperty}
                isAdmin={isAdmin || (isServiceProvider && isAdminCreateUser)}
                isServiceProvider={isServiceProvider}
                isAdminCreateUser={isAdminCreateUser}
                isTailwindComponent={isTailwindComponent}
                subscriptionbyAdmin={
                  isAdmin || (isServiceProvider && isAdminCreateUser)
                }
                showAllSubscriptionCategories={
                  isAdmin || (isServiceProvider && isAdminCreateUser)
                }
                workspaceUser={selectedRowData}
                completeProtectionOnly={completeProtectionOnly}
              />
            )}

            {screen === "security" ? (
              <PropertySearchType
                agreementCategory={agreementCategory}
                onBtnClick={(e) => {
                  // e.preventDefault();
                  console.log("submitted");
                }}
                handleCloseAddPropertyModal={handleCloseAddPropertyModal}
                isByPassOptionAvailable={
                  selectedCategory === "complete_protection"
                    ? isByPassOptionAvailable
                    : false
                }
                onChangeModalScreen={(src = "questions") => {
                  // Admin resume signup only: after Add Another Property, return to
                  // Owner Verified. Category-based plans are chosen from that screen.
                  if (
                    isResumeSignup &&
                    (src === "propertyList" || src === "security")
                  ) {
                    setScreen(src);
                    return;
                  }

                  // Basic / Enhanced have no ownership questions: never show an
                  // empty Security Questions step on admin resume signup.
                  if (
                    isResumeSignup &&
                    src === "questions" &&
                    selectedCategory !== "complete_protection"
                  ) {
                    setScreen("propertyList");
                    return;
                  }

                  if (src === "categoryWisePricing") {
                    setScreen("categoryWisePricing");
                    return;
                  }

                  if (
                    isAdminWorkspaceEnhancedAddProperty &&
                    ["questions", "subscriptions", "propertyList", "cardsInfo"].includes(src)
                  ) {
                    // Payment screen is only for Paid Enhanced.
                    if (!isAdminEldoradoComplimentaryEnhancedSelected()) {
                      setScreen("cardsInfo");
                    }
                    return;
                  }

                  if (src === "questions" || src === "cardsInfo") {
                    setScreen(src);
                    return;
                  }

                  // Customer /properties Add Property and SP personal: pick
                  // category after add-property-in-report — not ownership
                  // verification.
                  const isSpPersonalAddProperty =
                    isServiceProvider &&
                    !isAdminCreateUser &&
                    !isUpgradeCategory;
                  if (
                    isCustomer ||
                    isSpPersonalAddProperty ||
                    isUserCreateProperty
                  ) {
                    setScreen("categoryWisePricing");
                    return;
                  }

                  const isClientEnrollmentAdminFlow =
                    isAdmin || (isServiceProvider && isAdminCreateUser);

                  // After property search: monitoring tiers go to plans/payment;
                  // Complete Protection continues to questions (or bypass → subscriptions).
                  // Never override an explicit return to Owner Verified / Find Property.
                  if (
                    isClientEnrollmentAdminFlow &&
                    selectedCategory !== "complete_protection" &&
                    src !== "propertyList" &&
                    src !== "security" &&
                    !isResumeSignup
                  ) {
                    setScreen("subscriptions");
                    return;
                  }

                  // Upgrade and create-user Complete Protection: honor the
                  // requested next step (usually "questions" after generate-questions).
                  if (
                    selectedCategory === "complete_protection" ||
                    category === "complete_protection"
                  ) {
                    // Resume Add Another must not land on plans when callers omit src.
                    if (
                      isResumeSignup &&
                      (src === "questions" || !src) &&
                      isQuestionByPass
                    ) {
                      setScreen("propertyList");
                      return;
                    }
                    setScreen(src);
                    return;
                  }

                  setScreen(
                    isResumeSignup ? "propertyList" : src || "propertyList",
                  );
                }}
                onCloseModalHandler={(result) => {
                  if (
                    !isByPassOptionAvailable ||
                    result === "success" ||
                    isUpgradeCategory
                  ) {
                    if (typeof getPropertyList === "function") {
                      getPropertyList();
                    }
                  }
                  // Complimentary Enhanced: payment runs from Owner Verification
                  // Next; closing Add Property still refreshes after success.
                  if (
                    result === "success" &&
                    from === "add-property" &&
                    !isResumeSignup &&
                    (selectedCategory === "basic_monitoring" ||
                      (selectedCategory === "enhanced_monitoring" &&
                        isAdminEldoradoComplimentaryEnhancedSelected()))
                  ) {
                    handleCloseAddPropertyModal("success");
                    return;
                  }
                  if (isResumeSignup || (isAssistant && !enablePaymentScreen)) {
                    setScreen("propertyList");
                  } else {
                    setScreen("subscriptions");
                  }
                  // handleCloseAddPropertyModal();
                }}
                isAdminCreateUser={isAdminCreateUser}
                user_id={user_id}
                isResumeSignup={isResumeSignup}
                selectedRowData={selectedRowData}
                isAssistant={isAssistant}
                enablePaymentScreen={enablePaymentScreen}
                user_category={isResumeSignup ? category : selectedCategory}
                backToCategoryWisePricingScreen={() =>
                  // No pricing step to return to when only one category exists.
                  completeProtectionOnly
                    ? handleCloseAddPropertyModal()
                    : setScreen("categoryWisePricingFromAdmin")
                }
                isAdmin={isAdmin}
                isUpgradeCategory={isUpgradeCategory}
                userEmail={userEmail}
                isTailwindComponent={isTailwindComponent}
                isServiceProvider={isServiceProvider}
                isCustomer={isCustomer}
                isFromRiskReport={isFromRiskReport}
                isUserCreateProperty={isUserCreateProperty}
                isShow={!isTailwindComponent}
              />
            ) : showCarInviteChoice ? (
              carChoiceRows.loading ? (
                <Loader open={true} />
              ) : (
                <CarInviteChoice
                  portfolioIds={carChoiceRows.ids}
                  doneLabel="Back to client"
                  onPurchase={() => setCarPurchaseChosen(true)}
                  // No Back here: the popup's close button leaves the flow.
                  onDone={leaveCarInviteChoice}
                />
              )
            ) : (
              <SecurityInfoAndCardPayment
                completeProtectionOnly={completeProtectionOnly}
                skipOwnerVerifiedPage={skipCarOwnerVerifiedPage({
                  isServiceProvider,
                  completeProtectionOnly,
                  enrollmentKind: carPrefillEnrollmentKind(),
                })}
                // No startFromPropertyList after Invite or Purchase: the plans
                // and Activate Plan quote only the property just added, as
                // before that step existed.
                screen={screen}
                onChangeModalScreen={setScreen}
                backToSearchProperty={setScreen}
                handleCloseAddPropertyModal={handleCloseAddPropertyModal}
                from={from}
                onCloseModalHandler={(type) => {
                  if (
                    type === "success" ||
                    type === "pin-complete" ||
                    (!isByPassOptionAvailable && callListingAPI)
                  ) {
                    if (typeof getPropertyList === "function") {
                      getPropertyList();
                    }
                  }

                  if (type === "pin-complete") {
                    handleCloseAddPropertyModal("success");
                    return;
                  }

                  if (
                    type === "success" &&
                    carPaymentEndsWithWelcomeEmail({
                      isServiceProvider,
                      completeProtectionOnly,
                      client: selectedRowData,
                    })
                  ) {
                    sessionStorage.removeItem(CAR_SKIP_OWNER_PIN);
                    sendCarClientWelcomeEmail();
                    return;
                  }

                  if (type === "success" && shouldSkipCarOwnerPin()) {
                    sessionStorage.removeItem(CAR_SKIP_OWNER_PIN);
                    handleCloseAddPropertyModal("success");
                    return;
                  }

                  // Hide this code to skip security pin after Enhancedpayment
                  // if (type === "success" && skipSecurityPinAfterPayment) {
                  //   handleCloseAddPropertyModal("success");
                  //   return;
                  // }

                  const isCompleteProtectionTarget =
                    selectedCategory === "complete_protection" ||
                    category === "complete_protection";
                  const isCpUpgrade =
                    (isUpgradeCategory || isEnhancedToCompleteProtection) &&
                    isCompleteProtectionTarget;
                  const pinUserData = isCustomer ? userData : selectedRowData;

                  const needsPinAfterCpUpgrade =
                    type === "success" &&
                    isCpUpgrade &&
                    !userHasSecurityPin(pinUserData);
                  const needsPinAfterAdminCreate =
                    type === "success" &&
                    !closeAfterAddingProperty &&
                    isAdminCreateUser &&
                    selectedRowData?.json_last_step?.step < 4 &&
                    !userHasSecurityPin(selectedRowData) &&
                    isCompleteProtectionTarget;

                  const isEnhancedMonitoringResumeSignup =
                    isResumeSignup && category === "enhanced_monitoring";

                  if (
                    type === "success" &&
                    isEnhancedMonitoringResumeSignup
                  ) {
                    dispatch(propertiesAction.addNewProperty({}));
                    setScreen("welcome");
                    return;
                  }

                  if (needsPinAfterCpUpgrade || needsPinAfterAdminCreate) {
                    dispatch(propertyUsersAction.fetchSecurityPINData({}));
                    setScreen("security-pin");
                    return;
                  }

                  handleCloseAddPropertyModal(type);
                }}
                isByPassOptionAvailable={isByPassOptionAvailable}
                selectedData={selectedData}
                addPromoCode={true}
                skipVerification={isAssistant ? true : skipVerification}
                setSkipVerification={setSkipVerification}
                isUserCreateProperty={isUserCreateProperty}
                completedProcess={completedProcess}
                user_id={user_id}
                isAdminCreateUser={isAdminCreateUser}
                selectedRowData={selectedRowData}
                isResumeSignup={isResumeSignup}
                promoCode={promoCode}
                titleCompanyUser={allowedPrefix}
                isAssistant={isAssistant}
                enablePaymentScreen={enablePaymentScreen}
                setIsPropertyAdded={() => {
                  if (isAssistant && !enablePaymentScreen) {
                    handleCloseAddPropertyModal();
                  }
                }}
                user_category={selectedCategory}
                isAdmin={isAdmin}
                isUpgradeCategory={isUpgradeCategory}
                userEmail={userEmail}
                isTailwindComponent={isTailwindComponent}
                isServiceProvider={isServiceProvider}
                disableBasicMonitoring={disableBasicMonitoring}
                onGenerateSecurityQuestions={onGenerateSecurityQuestions}
                isEnhancedToCompleteProtection={isEnhancedToCompleteProtection}
                ownershipVerificationAlreadyComplete={
                  ownershipVerificationAlreadyComplete
                }
                ownershipVerifiedViaId={ownershipVerifiedViaId}
              />
            )}
          </DialogContentText>
        </DialogContent>
        {!showSecurityHeaderToCheckout && screen === "cardsInfo" && (
          <DialogActions sx={{ paddingBottom: "50px" }}>
            <div className="text-center mt-3 mb-0 w-100">
              <img src={Aurthorised} alt="Aurthorised" />
            </div>
          </DialogActions>
        )}
      </Dialog>
      {carWelcomeEmail.sending || carWelcomeEmail.error ? (
        <AlertDialog
          type="Error"
          openPopup={Boolean(carWelcomeEmail.error)}
          loader={carWelcomeEmail.sending}
          mesage={carWelcomeEmail.error}
          isTailwindComponent={isTailwindComponent}
          onCloseFun={() => {
            // Dismissed: the payment is done, so leave the popup.
            setCarWelcomeEmail({ sending: false, error: "" });
            handleCloseAddPropertyModal("success");
          }}
          buttons={
            <Button
              className="popup_Btn success_popup_btn"
              onClick={sendCarClientWelcomeEmail}
            >
              Try again
            </Button>
          }
        />
      ) : null}
      {/* {openAlertModal && !cardDetails?.data?.length > 0 && (
        <>
          <AlertDialog
            type="Warning"
            openPopup={openAlertModal}
            onClose={true}
            onCloseFun={() => {
              setOpenAlertModal(false);
            }}
            buttons={
              <>
                <Button
                  className="popup_Btn success_popup_btn mx-2"
                  sx={{
                    backgroundColor: "#ffffff !important",
                    color: "black !important",
                    border: "1px #9cb8a6 solid !important",
                  }}
                  onClick={() => {
                    setOpenAlertModal(false);
                  }}
                >
                  ok, close
                </Button>
                <Button
                  className="popup_Btn success_popup_btn mx-2"
                  onClick={() => {
                    setOpenAlertModal(false);
                    if (
                      userData?.user_type?.includes(ROLES?.professional) &&
                      !userData?.role?.includes(ROLES?.customer)
                    ) {
                      navigate("/professional-profile", {
                        replace: true,
                        state: { isAddPaymentModal: true },
                      });
                    } else {
                      navigate("/user-profile", {
                        replace: true,
                        state: { isAddPaymentModal: true },
                      });
                    }
                  }}
                >
                  ok, let's go
                </Button>
              </>
            }
            mesage={
              "You don't have any cards added. Please add the card first from the user profile page."
            }
            footer={false}
          />
        </>
      )} */}
    </>
  );
};

export default AddPropertyPopup;
